module.exports = __webpack_public_path__ + "media/images/emblems/Oppens-coat_of_arms-46ffe1a277e6600b13ad05773b6ea732.svg";